import { baseApi } from "@/redux/api/baseApi";
import { TResponseRedux } from "@/types/types";
import { TProductShipping } from "./productShippingTypes";

const productShippingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProductShipping: builder.query<
      TResponseRedux<TProductShipping>,
      { orderId: string | undefined; videoId: string | null }
    >({
      query: (payload) => ({
        url: `/product-shipping/get-product-shipping-details-creator/${payload.orderId}/${payload.videoId}`,
        method: "GET",
      }),
      providesTags: ["ProductShipping"],
    }),
    uploadReceiptProof: builder.mutation({
      query: (payload) => ({
        url: `/product-shipping/upload-receipt-proof/${payload.order_id}/${payload.video_id}`,
        method: "POST",
        body: payload.data,
      }),
      invalidatesTags: ["ProductShipping"],
    }),
    uploadPurchasingInvoice: builder.mutation({
      query: (payload) => ({
        url: `/product-shipping/upload-purchase-invoice/${payload.order_id}/${payload.video_id}`,
        method: "POST",
        body: payload.data,
      }),
      invalidatesTags: ["ProductShipping"],
    }),
    reportProductShippingIssue: builder.mutation({
      query: (payload) => ({
        url: `/product-shipping/report-issue/${payload.order_id}/${payload.video_id}`,
        method: "POST",
        body: payload.data,
      }),
      invalidatesTags: ["ProductShipping"],
    }),
    confirmProductShippingAddress: builder.mutation({
      query: ({ orderId, videoId, shippingId }) => ({
        url: `/product-shipping/confirm-shipping-address/${orderId}/${videoId}/${shippingId}`,
        method: "POST",
      }),
      invalidatesTags: ["ProductShipping"],
    }),
  }),
});

export const {
  useConfirmProductShippingAddressMutation,
  useReportProductShippingIssueMutation,
  useGetProductShippingQuery,
  useUploadPurchasingInvoiceMutation,
  useUploadReceiptProofMutation,
} = productShippingApi;
